var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 489,
    height: 489,
    viewBox: "0 0 489 489",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M488.8 383V9.9C488.8 4.4 484.4 0 478.9 0H105.8C100.3 0 95.9 4.4 95.9 9.9V383C95.9 388.5 100.3 392.9 105.8 392.9H478.9C484.4 392.9 488.8 388.5 488.8 383ZM469 373.1H115.7V19.8H469V373.1Z",
    fill: "#1D1D1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.9 488.8H383C388.5 488.8 392.9 484.4 392.9 478.9C392.9 473.4 388.5 469 383 469H19.8V105.8C19.8 100.3 15.4 95.9 9.9 95.9C4.4 95.9 0 100.3 0 105.8V478.9C0 484.4 4.4 488.8 9.9 488.8Z",
    fill: "#1D1D1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.8 206.3H282.5H286C294.5 206.3 287.5 206.3 293 206.3C298.5 206.3 292.3 206.3 302.3 206.3H373C378.5 206.3 382.9 201.9 382.9 196.4C382.9 190.9 378.5 186.5 373 186.5H302.3C291.5 186.5 297.5 186.5 292 186.5C286.5 186.5 291 186.5 284.5 186.5L211.8 186.5C206.3 186.5 201.9 190.9 201.9 196.4C201.9 201.9 206.3 206.3 211.8 206.3Z",
    fill: "#F4B536"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_10"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 488.8,
    height: 488.8,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.8c8fb771b948e6b169077174fb16fd40.svg";
export { ForwardRef as ReactComponent };